/* eslint-disable react/jsx-pascal-case */
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle";
import './App.css';
import HeaderElement from './components/HeaderElement';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { CountryProvider } from './context/CountryContext';
import Track from "./components/pages/Track";
import Help from "./components/pages/Help";
import Partners from "./components/pages/Partners";
import Business from "./components/pages/Business";
import Footer from "./components/Footer";
import Individuals from "./components/pages/your-business/Individuals";
import SMEs from "./components/pages/your-business/SMEs";
import Corporates from "./components/pages/your-business/Corporates";
import How_it_works from "./components/pages/How_it_works";
import Terms_and_Conditions from "./components/pages/Terms_and_Conditions";
import About_us from "./components/pages/About_us";
import Login from "./components/pages/Login";
import Home1 from "./components/pages/Home1";
import Quote from "./components/pages/Quote";
import QuoteList from "./components/pages/QuoteList";
import Order_detail from "./components/pages/Order_detail";
import Orderlist_detail from './components/pages/Order_detail1';
import Awblabel from "./components/pages/Awblabel";
import Checkout from "./components/pages/Checkout";
import After_payment from "./components/pages/After_payment";
import Send from "./components/pages/Send";
import Schedule_pickup from "./components/pages/home_components/track/Schedule_pickup";
import International_courier_services from "./components/pages/International_courier_services";
import Local_courier_same_day_courier from "./components/pages/Local_courier_same_day_courier";
import My_parcels from "./components/pages/my_account/My_parcels";
import Quick_quote from "./components/pages/my_account/Quick_quote";
import Multiple_Quick_quote from "./components/pages/my_account/Multiple_Quick_quote";
import Heavy_Quick_quote from "./components/pages/my_account/Heavy_Quick_quote";
import Document_quote from "./components/pages/my_account/Document_quote";
import Multiple_Document_quote from "./components/pages/my_account/Multiple_Document_quote";
import Heavy_Document_quote from "./components/pages/my_account/Heavy_Document_quote";
import Domestic_quote from "./components/pages/my_account/Domestic_quote";
import My_wallet from "./components/pages/my_account/My_wallet";
import After_wallet_payment from "./components/pages/my_account/After_wallet_payment";
import Address_book from "./components/pages/my_account/Address_book";
import Add_address from "./components/pages/my_account/Add_address";
import Settings from "./components/pages/my_account/Settings";
import Client_zone from "./components/pages/Client_zone";
import Dashboard from "./components/pages/dashboard/Dashboard";
import Domestic_orders from "./components/pages/dashboard/Domestic_orders";
import International_orders from "./components/pages/dashboard/International_orders";
import TrackAWB from "./components/pages/TrackAWB";
import Sameday_service from "./components/pages/Sameday_service";
import Prohibited_items from "./components/pages/Prohibited_items";
import Packaging_advice from "./components/pages/Packaging_advice";
import Testimonials from "./components/pages/Testimonials";
import Contact from "./components/pages/Contact";
import Improving_lives from "./components/pages/Improving_lives";
import Medical_services from "./components/pages/Medical_services";
import Friday_service from "./components/pages/Friday_service";
import Become_driver from "./components/pages/Become_driver";
import Privacy_cookies from "./components/pages/Privacy_cookies";
import Sales_enquries from "./components/pages/Sales_enquries";
import Howitworks from "./components/pages/Howitworks";
import Open_wallet from "./components/pages/Open_wallet";
import Shop_usa from "./components/pages/Shop_usa";
import Bulk_upload from "./components/pages/Bulk_upload";
import Sending_multiple from "./components/pages/Sending_multiple";
import Collect_drop from "./components/pages/Collect_drop";
import Download from "./components/pages/Download";
import TakeAdvantageofcheapflight from "./components/pages/TakeAdvantageofcheapflight";
import FindOutParcel from "./components/pages/FindOutParcel";
import Rearrange_delivery from "./components/pages/Rearrange_delivery";
import Reset_password from "./components/pages/Reset_password";
import Customs_clearance from "./components/pages/Customs_clearance";
import Register_test from "./components/pages/Register_test";
import AwblabelAramex from "./components/pages/AwblabelAramex";
import Sonoco from "./components/pages/Sonoco";
import ScrollToTop from "./components/pages/ScrollToTop ";
import Careers from "./components/pages/Careers";
import Articles from "./components/pages/Articles";
import IncredibleLogistics from "./components/pages/articles/IncredibleLogistics";
import GlobalReach from "./components/pages/articles/GlobalReach";
import CompetetivePrices from "./components/pages/articles/CompetetivePrices";
import FleetProductivity from "./components/pages/articles/FleetProductivity";
import ParcelServiceReseller from "./components/pages/articles/ParcelServiceReseller";
import SaveShippingcost from "./components/pages/articles/SaveShippingcost";
import TakeBusinessOnline from "./components/pages/articles/TakeBusinessOnline";
import B2bB2CVendors from "./components/pages/articles/B2bB2CVendors";
import Rating from "./components/pages/Rating";
import Pricing from "./components/pages/Pricing";
import PricingLogin from "./components/pages/PricingLogin";
import Subscription from "./components/pages/Subscription";
import Corporate_sme from "./components/pages/Corporate_sme";
import Bulk_orders from "./components/pages/my_account/Bulk_orders";
import Bulk_awblabel from "./components/pages/Bulk_awblabel";
import After_payment_bulkorder from "./components/pages/After_payment_bulkorder";
import BulkAWBAramex from "./components/pages/BulkAWBAramex";
import SendParcelsWithTimex from "./components/pages/articles/SendParcelsWithTimex";
import Next_day_service from "./components/pages/Next_day_service";
import Bullet_service from "./components/pages/Bullet_service";
import Ecommerce_services from "./components/pages/Ecommerce_services";
import Online_booking from "./components/pages/Online_booking";
import Cheap_parcel_delivery from "./components/pages/Cheap_parcel_delivery";
import Send_parcels_US from "./components/pages/Send_parcels_US";
import Send_parcels_UK from "./components/pages/Send_parcels_UK";
import Fine_arts_enquries from "./components/pages/Fine_arts_enquries";
import Analytics from "./components/pages/my_account/Dashboard";
import Verify from "./components/pages/Verify";
import QuoteHeavyList from "./components/pages/QuoteHeavyList";
import OrderHeavy_details from "./components/pages/OrderHeavy_details";
import CountryManagement from "./components/pages/admin/CountryManagement";
import AdminLogin from "./components/pages/admin/AdminLogin";
import ProtectedRoute from "./components/admin/ProtectedRoute";

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <CountryProvider>
          <ScrollToTop>
            {window.location.pathname !== "/staff-discount-register" && 
             window.location.pathname !== "/admin/countries" && 
             window.location.pathname !== "/admin/login" ? <HeaderElement /> : null}{" "}

            <Routes>
            {/* Default routes (no country prefix) */}
            <Route path="/" element={<Home1 />}></Route>
            <Route path="/home" element={<Home1 />}></Route>
            <Route path="/domestic" element={<Home1 />}></Route>
            <Route path="/track" element={<Track />}></Route>
            
            {/* Country-specific routes (with country prefix like /au, /sa, /om, etc.) */}
            <Route path="/:country" element={<Home1 />}></Route>
            <Route path="/:country/home" element={<Home1 />}></Route>
            <Route path="/:country/domestic" element={<Home1 />}></Route>
            <Route path="/:country/track" element={<Track />}></Route>
            <Route path="/your-business" element={<Business />}></Route>
            <Route path="/send" element={<Send />}></Route>
            <Route path="/help/*" element={<Help />}></Route>
            <Route path="/become-a-partner/*" element={<Partners />}></Route>
            <Route path="/your-business/individuals/" element={<Individuals />}></Route>
            <Route path="/your-business/smes/" element={<SMEs />}></Route>
            <Route path="/your-business/corporates/" element={<Corporates />}></Route>
            <Route path="/parcels-on-demand" element={<How_it_works />}></Route>
            <Route path="/terms-conditions" element={<Terms_and_Conditions />}></Route>
            <Route path="/privacy-cookies" element={<Privacy_cookies />}></Route>
            <Route path="/about-us" element={<About_us />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/register" element={<Register_test />}></Route>
            
            {/* Country-specific versions of common pages */}
            <Route path="/:country/your-business" element={<Business />}></Route>
            <Route path="/:country/send" element={<Send />}></Route>
            <Route path="/:country/help/*" element={<Help />}></Route>
            <Route path="/:country/become-a-partner/*" element={<Partners />}></Route>
            <Route path="/:country/your-business/individuals/" element={<Individuals />}></Route>
            <Route path="/:country/your-business/smes/" element={<SMEs />}></Route>
            <Route path="/:country/your-business/corporates/" element={<Corporates />}></Route>
            <Route path="/:country/parcels-on-demand" element={<How_it_works />}></Route>
            <Route path="/:country/terms-conditions" element={<Terms_and_Conditions />}></Route>
            <Route path="/:country/privacy-cookies" element={<Privacy_cookies />}></Route>
            <Route path="/:country/about-us" element={<About_us />}></Route>
            <Route path="/:country/login" element={<Login />}></Route>
            <Route path="/:country/register" element={<Register_test />}></Route>
            <Route path="/quotation" element={<Quote />}></Route>
            <Route path="/quotationList" element={<QuoteList />}></Route>
            <Route path="/quotationHeavyList" element={<QuoteHeavyList />}></Route>
            <Route path="/order-detail" element={<Order_detail />}></Route>
            <Route path="/orderlist-detail" element={<Orderlist_detail />}></Route>
            <Route path="/orderheavylist-detail" element={<OrderHeavy_details />}></Route>
            <Route path="/awb-label" element={<Awblabel />}></Route>
            <Route path="/checkout" element={<Checkout />}></Route>
            <Route path="/after-payment/*" element={<After_payment />}></Route>
            <Route path="/track/schedule-your-pick-up-and-delivery-time" element={<Schedule_pickup />}></Route>
            <Route path="/international-courier-services" element={<International_courier_services />}></Route>
            <Route path="/send/local-courier-same-day-courier" element={<Local_courier_same_day_courier />}></Route>
            <Route path="/my-account/my-parcels" element={<My_parcels />}></Route>
            <Route path="/my-account/dashboard" element={<Analytics />}></Route>
            <Route path="/my-account/quick-quote" element={<Quick_quote />}></Route>
            <Route path="/my-account/multiple-quick-quote" element={<Multiple_Quick_quote />}></Route>
            <Route path="/my-account/heavy-quick-quote" element={<Heavy_Quick_quote />}></Route>
            <Route path="/my-account/document-quote" element={<Document_quote />}></Route>
            <Route path="/my-account/multiple-document-quote" element={<Multiple_Document_quote />}></Route>
            <Route path="/my-account/heavy-document-quote" element={<Heavy_Document_quote />}></Route>
            <Route path="/my-account/domestic-quote" element={<Domestic_quote />}></Route>
            <Route path="/my-account/my-wallet" element={<My_wallet />}></Route>
            <Route path="/my-account/after-wallet-payment" element={<After_wallet_payment />}></Route>
            <Route path="/my-account/address-book" element={<Address_book />}></Route>
            <Route path="/my-account/delivey-address" element={<Add_address />}></Route>
            <Route path="/my-account/settings" element={<Settings />}></Route>
            <Route path="/client-zone" element={<Client_zone />}></Route>
            <Route path="/dashboard" element={<Dashboard />}></Route>
            <Route path="/dashboard/domestic-orders" element={<Domestic_orders />}></Route>
            <Route path="/dashboard/international-orders" element={<International_orders />}></Route>
            <Route path="/track/*" element={<TrackAWB />}></Route>
            <Route path="/track/same-day-delivery/" element={<Sameday_service />}></Route>
            <Route path="/prohibited-restricted-items" element={<Prohibited_items />}></Route>
            <Route path="/packaging-advice" element={<Packaging_advice />}></Route>
            <Route path="/testimonials" element={<Testimonials />}></Route>
            <Route path="/contact-time-express" element={<Contact />}></Route>
            <Route path="/improving-lives" element={<Improving_lives />}></Route>
            <Route path="/medical-services" element={<Medical_services />}></Route>
            <Route path="/track/friday-delivery" element={<Friday_service />}></Route>
            <Route path="/track/sunday-delivery" element={<Friday_service />}></Route>
            <Route path="/become-a-driver" element={<Become_driver />}></Route>
            <Route path="/send/*" element={<Home1 />}></Route>
            <Route path="/sales-enquries" element={<Sales_enquries />}></Route>
            <Route path="/how-it-works" element={<Howitworks />}></Route>
            <Route path="/open-a-wallet-account" element={<Open_wallet />}></Route>
            <Route path="/shop-usa-ship-uae/" element={<Shop_usa />}></Route>
            <Route path="/send/our-bulk-upload-tools" element={<Bulk_upload />}></Route>
            <Route path="/send/sending-multiple-parcels-discount-tool" element={<Sending_multiple />}></Route>
            <Route path="/collect-or-drop-off-parcel" element={<Collect_drop />}></Route>
            <Route path="/download" element={<Download />}></Route>
            <Route path="/download/*" element={<Download />}></Route>
            <Route path="/track/take-advantage-of-cheap-freight-from-uae/" element={<TakeAdvantageofcheapflight />}></Route>
            <Route path="/track/find-out-where-your-parcel-is/" element={<FindOutParcel />}></Route>
            <Route path="/track/re-arrange-a-delivery/" element={<Rearrange_delivery />}></Route>
            <Route path="/reset-password" element={<Reset_password />}></Route>
            <Route path="/reset-password/*" element={<Reset_password />}></Route>
            <Route path="/customs-clearance-services" element={<Customs_clearance />}></Route>
            <Route path="/registertest/" element={<Register_test />}></Route>
            <Route path="/awb-label-aramex/" element={<AwblabelAramex />}></Route>
            <Route path="/sonoco-thermosafe" element={<Sonoco />}></Route>
            <Route path="/careers" element={<Careers />}></Route>
            <Route path="/blogs" element={<Articles />}></Route>
            <Route path="/blogs/incredible-logistics" element={<IncredibleLogistics />}></Route>
            <Route path="/blogs/global-reach" element={<GlobalReach />}></Route>
            <Route path="/blogs/competitive-prices" element={<CompetetivePrices />}></Route>
            <Route path="/blogs/overcoming-dedicated-fleet-productivity" element={<FleetProductivity />}></Route>
            <Route path="/blogs/7-compelling-reasons-why-you-should-use-a-parcel-service-reseller" element={<ParcelServiceReseller />}></Route>
            <Route path="/blogs/how-to-save-costs-in-shipping" element={<SaveShippingcost />}></Route>
            <Route path="/blogs/how-to-take-your-business-online/" element={<TakeBusinessOnline />}></Route>
            <Route path="/blogs/expand-your-brand-into-gcc/" element={<B2bB2CVendors />}></Route>
            <Route path="/rating" element={<Rating />}></Route>
            <Route path="/review" element={<Rating />}></Route>
            <Route path="/pricing" element={<Pricing />}></Route>
            <Route path="/pricing-login" element={<PricingLogin />}></Route>
            <Route path="/subscribe/*" element={<Subscription />}></Route>
            <Route path="/corporate-sme" element={<Corporate_sme />}></Route>
            <Route path="/my-account/bulk-upload" element={<Bulk_orders />}></Route>
            <Route path="/bulk-awb-label" element={<Bulk_awblabel />}></Route>
            <Route path="/after-payment-bulk" element={<After_payment_bulkorder/>}></Route>
            <Route path="/bulk-domestic-awb-label" element={<BulkAWBAramex />}></Route>
            <Route path="/blogs/how-to-send-a-parcel-for-less-with-time-express/" element={<SendParcelsWithTimex />}></Route>
            <Route path="/track/bullet-delivery" element={<Bullet_service />}></Route>
            <Route path="/track/next-day-delivery" element={<Next_day_service />}></Route>
            <Route path="/e-commerce-services" element={<Ecommerce_services />}></Route>
            <Route path="/online-booking" element={<Online_booking />}></Route>
            <Route path="/cheap-parcel-delivery" element={<Cheap_parcel_delivery />}></Route>
            <Route path="/send-parcel-to-usa" element={<Send_parcels_US />}></Route>
            <Route path="/send-parcel-to-uk" element={<Send_parcels_UK />}></Route>
            <Route path="/fine-arts-enquiries" element={<Fine_arts_enquries />}></Route>
            <Route path="/verify/*" element={<Verify />}></Route>
            <Route path="/admin/login" element={<AdminLogin />}></Route>
            <Route 
                path="/admin/countries" 
                element={
                    <ProtectedRoute>
                        <CountryManagement />
                    </ProtectedRoute>
                }
            ></Route>
            </Routes>
            {window.location.pathname !== "/staff-discount-register" && 
             window.location.pathname !== "/admin/countries" && 
             window.location.pathname !== "/admin/login" ? <Footer /> : null}{" "}

          </ScrollToTop>
        </CountryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;


